import { Link } from "@tanstack/react-router";
import { Menu, UserRound } from "lucide-react";
import { ThemeToggle } from "../theme-toggle";
import type { AuthUser } from "../../stores/auth";
import type { RefObject } from "react";

interface MobileAppBarProps {
  user: AuthUser | null;
  pageTitle: string;
  navigationOpen: boolean;
  accountOpen: boolean;
  onOpenNavigation(): void;
  onOpenAccount(): void;
  navigationButtonRef?: RefObject<HTMLButtonElement>;
  accountButtonRef?: RefObject<HTMLButtonElement>;
}

export function MobileAppBar({
  user,
  pageTitle,
  navigationOpen,
  accountOpen,
  onOpenNavigation,
  onOpenAccount,
  navigationButtonRef,
  accountButtonRef,
}: MobileAppBarProps) {
  return (
    <header className="mobile-app-bar sticky top-0 z-40 flex items-center gap-2 border-b border-border/70 bg-bg/95 px-2 backdrop-blur">
      {user ? (
        <button
          ref={navigationButtonRef}
          type="button"
          onClick={onOpenNavigation}
          aria-label="Open navigation"
          aria-haspopup="dialog"
          aria-expanded={navigationOpen}
          className="mobile-touch-target inline-flex shrink-0 items-center justify-center rounded text-muted transition-colors hover:bg-border/25 hover:text-fg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent"
        >
          <Menu className="h-5 w-5" aria-hidden="true" />
        </button>
      ) : (
        <span
          className="mobile-touch-target inline-flex shrink-0"
          aria-hidden="true"
        />
      )}

      <div className="min-w-0 flex-1 text-center leading-tight">
        <Link
          to="/"
          aria-label={`Dashboard — current page ${pageTitle}`}
          className="flex min-h-11 min-w-0 flex-col items-center justify-center rounded px-1 text-fg outline-none transition-colors hover:text-accent focus-visible:ring-2 focus-visible:ring-accent"
        >
          <span
            data-nonessential-decoration
            className="block w-full text-xs font-semibold tracking-[0.14em]"
          >
            CASCENA
          </span>
          <span className="block w-full break-words text-sm font-medium">
            {pageTitle}
          </span>
        </Link>
      </div>

      {user ? (
        <button
          ref={accountButtonRef}
          type="button"
          onClick={onOpenAccount}
          aria-label="Open account and preferences"
          aria-haspopup="dialog"
          aria-expanded={accountOpen}
          className="mobile-touch-target inline-flex shrink-0 items-center justify-center rounded text-muted transition-colors hover:bg-border/25 hover:text-fg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent"
        >
          <UserRound className="h-5 w-5" aria-hidden="true" />
        </button>
      ) : (
        <div className="mobile-app-bar-theme shrink-0">
          <ThemeToggle />
        </div>
      )}
    </header>
  );
}
